import React from 'react'
import dayjs from 'dayjs'
import { Value } from '../../pages_v2/elements'

export interface MobileField {
  key: string
  label: string
  render?: (value: any, record: any) => React.ReactNode
}

const formatPhone = (num: string) => {
  if (!num || num.length !== 11) return null
  return num.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, '+$1 ($2) $3-$4-$5')
}

export const getMobileFields = (enums?: any): MobileField[] => [
  {
    key: 'id',
    label: '', 
    render: (val) => `Запись №${val}`,
  },
  {
    key: 'fio',
    label: 'ФИО кандидата',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'phone',
    label: 'Телефон',
    render: (val) => formatPhone(String(val)),
  },
  {
    key: 'department',
    label: 'Отдел',
    render: (val) => {
      const departmentName = enums?.department?.find(i => i.value === val)?.label
      return <Value data={departmentName} />
    },
  },
  {
    key: 'vacancy',
    label: 'Вакансия',
    render: (val) => <Value data={val} />,
  },
  {
    key: 'manager_id',
    label: 'Менеджер',
    render: (val, record) => {
      const manager = val || record.created_by
      const managerName = enums?.interview_responsible?.find(i => i.value === manager)?.label
      return <Value data={managerName} />
    },
  },
  {
    key: 'created_at',
    label: 'Дата создания',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY HH:mm') : <Value data={val} />),
  },
  {
    key: 'datetime_interview',
    label: 'Дата собеседования',
    render: (val) => (val ? dayjs(val).format('DD.MM.YYYY HH:mm') : <Value data={val} />),
  },
  {
    key: 'interview_type',
    label: 'Тип собеседования',
    render: (val) => {
      const typeName = enums?.interview_type?.find(i => i.value === val)?.label
      return <Value data={typeName} />
    },
  },
]

